import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from 'shared/components/Buttons';

const InformationPersonal = ({ onCancel }) => {
  const { t } = useTranslation();
  const theme = useSelector((state) => state.theme);
  const { socialReason } = theme;

  const Title = () => {
    return (
      <Row className="row-title">
        <Col sm={12} className="ml-n3">
          <h3>{t('login_information_data_personals')}</h3>
        </Col>
      </Row>
    );
  };
  return (
    <>
      <Title />
      <p className="information-message">
        <Trans>
          {t('login_information_data_personals_message', {
            value: socialReason && socialReason !== '' ? socialReason : t('login_social_reason'),
          })}
        </Trans>
      </p>
      <div className="action-information">
        <Button
          className="text-uppercase"
          type="button"
          color="primary"
          label={t('general_button_ok')}
          onClick={onCancel}
        />
      </div>
    </>
  );
};

InformationPersonal.defaultProps = {};

InformationPersonal.propTypes = {
  onCancel: PropTypes.func.isRequired,
};

export default InformationPersonal;
